import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import BackgroundImage from '../../../../asset/mama/background.png';
import { Header } from '../../container/header/header';
import { HomeContainer } from '../../container/home';

export const Page: React.FC<RouteComponentProps> = () => {
  return (
    <>
      <Layout>
        <BackgroundImageHolder>
          {/* <SnowfallElem /> */}
          <Header />
          <HomeContainer />

          {/* <Wheel /> */}
          {/* <Footer /> */}
        </BackgroundImageHolder>
      </Layout>
    </>
  );
};

export const BackgroundImageHolder = styled.div`
  background-image: url(${BackgroundImage});
  background-repeat: repeat;
  background-size: 100% auto;
  background-attachment: scroll;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
`;

const Layout = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  overflow-x: hidden;
`;
